import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { convertPxToVw } from '../../utils';
let Index = class Index extends Vue {
    constructor() {
        super(...arguments);
        this.vip_config = null;
        this.list = [];
    }
    get boxStyle() {
        return `background: ${this.data.bgColor || '#F5F5F5'};
            padding: 0 ${convertPxToVw(this.data.compMargin)}vw;
            --contentMargin: ${convertPxToVw((this.data.spacing || 0) / 2)}vw;
            --conentRadio2: ${convertPxToVw((this.data.spacing / 3) * 2)}vw;
            --conentRadio3: ${convertPxToVw(this.data.spacing / 3)}vw`;
    }
    get noticeStyle() {
        return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px 10px 0px 10px`;
    }
    get canShowWhite() {
        return this.data.lineRule === 'three';
    }
    get radiusStyle() {
        if (this.canShowWhite) {
            if (this.data.whiteCard) {
                return {
                    margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
                    'border-radius': this.data.radius + 'px',
                    background: '#fff',
                    padding: '5px',
                };
            }
            else {
                return {
                    margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
                    'border-radius': this.data.radius + 'px',
                    background: this.data.bgColor || '#f5f6f6',
                    padding: '0px',
                };
            }
        }
        else {
            return {
                margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
                'border-radius': this.data.radius + 'px',
                background: this.data.lineRule === 'one'
                    ? '#fff'
                    : this.data.bgColor || '#f5f6f6',
            };
        }
    }
    get coverFill() {
        return `object-fit: ${this.data.filling}; ${this.radiusStyle}`;
    }
    get fontStyle() {
        return {
            'font-weight': this.data.fontWeight ? 'bold' : 'normal',
        };
    }
    async mounted() {
        env.init();
        this.getaudiosList();
    }
    async getaudiosList() {
        if (this.config && this.config.vip_config) {
            this.vip_config = this.config.vip_config;
        }
        let audio_ids = this.data.audios.map(audio => audio.id);
        if (audio_ids && audio_ids.length) {
            let { data } = await this.$axios.post('/api/audios/resource/audio/audiosByIds', {
                ids: audio_ids,
            });
            let map = new Map();
            data.forEach(element => {
                map.set(element.id, element);
            });
            this.list = [];
            this.data.audios.map(r => {
                if (map.get(r.id)) {
                    this.list.push(map.get(r.id));
                }
            });
        }
        else {
            this.list = [];
        }
        if (!this.data.showUnPublish) {
            this.list = this.list.filter(r => !!r.is_publish);
        }
        if (!this.data.hidden) {
            this.list = this.list.filter(r => !!r.is_searchable);
        }
    }
    formatPlayCount(data) {
        let count = data.playcount || 1000;
        if (+count >= 100000000)
            return `${(+count / 100000000).toFixed(1)}亿`;
        if (+count >= 10000)
            return `${(+count / 10000).toFixed(1)}万`;
        return count || 0;
    }
    goAudio(value) {
        if (!value.is_publish) {
            return this.$Toast('音频暂未上架~');
        }
        // if (env.type === 'ivydad') {
        // env.commonJump(`ivydadreadtool://detail/audio?id=${value.id}`)
        let conf = env.getParams('audio', value.id);
        env.commonJump(conf.path, conf.params, { showCancelButton: true });
        // } else {
        //   openApp()
        // }
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], Index.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], Index.prototype, "compData", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], Index.prototype, "config", void 0);
Index = tslib_1.__decorate([
    Component({
        inheritAttrs: false,
    })
], Index);
export default Index;
